<div class="page-shell page-shell--canvas">

  <form
    [formGroup]="form"
    class="dc-wrapper signature-editor-page"
  >
    <div class="dc-header">
      <div class="dc-header__start">
        <mat-form-field appearance="outline" class="dc-name-field">
          <mat-label>{{ "footers.name" | translate }}</mat-label>
          <input matInput formControlName="name" type="text" />
        </mat-form-field>
      </div>
      <div class="dc-header__actions">
        <button mat-stroked-button type="button" (click)="goToSignatures()">
          {{ "cancel" | translate }}
        </button>
        <button
          *ngIf="generatorUrl"
          mat-stroked-button
          type="button"
          (click)="redirectToGenerator()"
        >
          {{ "footers.previewInGenerator" | translate }}
        </button>
        <ng-container
          *ngIf="
            footer?.numberOfInstallations > 0 ||
              footer?.numberOfAliases > 0 ||
              footer?.numberOfInternalInstallations > 0 ||
              footer?.numberOfInternalAliases > 0;
            else saveAndInstallBtn
          "
        >
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="saveAndInstall()"
            [disabled]="updating || loading || !footer"
          >
            <mat-spinner
              *ngIf="updating"
              diameter="20"
              class="dc-btn-spinner"
            ></mat-spinner>
            {{ (updating ? "saving" : "saveAndReinstall") | translate }}
          </button>
        </ng-container>
        <ng-template #saveAndInstallBtn>
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="saveAndInstall()"
            [disabled]="updating || loading || !footer"
          >
            <mat-spinner
              *ngIf="updating"
              diameter="20"
              class="dc-btn-spinner"
            ></mat-spinner>
            {{ (updating ? "saving" : "saveAndInstall") | translate }}
          </button>
        </ng-template>
        <button
          mat-raised-button
          type="button"
          color="primary"
          [disabled]="updating || loading || !footer"
          (click)="save()"
        >
          <mat-spinner
            *ngIf="updating"
            diameter="20"
            class="dc-btn-spinner"
          ></mat-spinner>
          {{ (updating ? "saving" : "save") | translate }}
        </button>
      </div>
    </div>

    <div class="dc-editor-grid">
      <div class="dc-section dc-preview-panel dc-preview-panel--editor">
        <div class="dc-section__content dc-preview-panel__body">
          <h3 class="dc-preview-panel__title">
            {{ "footers.previewTitle" | translate }}
          </h3>
          <div class="dc-employee-picker-wrap dc-editor-preview-employee-picker">
            <app-digital-card-employee-picker
              [value]="previewEmployee"
              (valueChange)="onPreviewEmployeeChange($event)"
            ></app-digital-card-employee-picker>
          </div>
          <div class="dc-preview-panel__stage">
            <div class="preview" #previewContainer>
              <div
                [innerHTML]="preview$ | async"
                appScaleContent
                [appScaleContent]="previewContainer"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="dc-section dc-form-panel">
        <div class="dc-section__content">
          <app-editor
            #signatureEditor
            formControlName="content"
            [height]="600"
          ></app-editor>
        </div>
      </div>
    </div>

    <div class="dc-section dc-tools-panel">
      <div class="dc-section__content">
        <div class="dynamic-menu">
          <div class="menu-buttons">
            <button
              mat-raised-button
              type="button"
              (click)="toggleSection('addons')"
            >
              <mat-icon>add_box</mat-icon>
              {{ "footers.addons" | translate }}
            </button>
            <button
              mat-raised-button
              type="button"
              (click)="toggleSection('variables')"
            >
              <mat-icon>code</mat-icon>
              {{ "footers.variables" | translate }}
            </button>
            <button
              mat-raised-button
              type="button"
              (click)="toggleSection('dynamicVariables')"
            >
              <mat-icon>tune</mat-icon>
              {{ "footers.dynamicVariables" | translate }}
            </button>
          </div>

          <div class="menu-content">
            <div class="section" [class.hidden]="activeSection !== 'addons'">
              <app-addons [form]="form" (ready)="onAddonsReady()"></app-addons>
            </div>

            <div
              class="section"
              [class.hidden]="activeSection !== 'dynamicVariables'"
            >
              <div class="form">
                <div class="field-row">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{
                      "footers.userAvatarWidth" | translate
                    }}</mat-label>
                    <input
                      matInput
                      formControlName="userAvatarWidth"
                      type="number"
                      min="0"
                    />
                    <span matSuffix>px</span>
                  </mat-form-field>

                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{
                      "footers.userAvatarBorderRadius" | translate
                    }}</mat-label>
                    <input
                      matInput
                      formControlName="userAvatarBorderRadius"
                      type="number"
                      min="0"
                      max="50"
                    />
                    <span matSuffix>%</span>
                  </mat-form-field>
                </div>

                <div class="field-row" *ngIf="digitalCardEnabled">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{
                      "footers.qrDigitalCardWidth" | translate
                    }}</mat-label>
                    <input
                      matInput
                      formControlName="qrDigitalCardWidth"
                      type="number"
                      min="0"
                    />
                    <span matSuffix>px</span>
                  </mat-form-field>

                  <app-searchable-select
                    formControlName="digitalCardProfileId"
                    [label]="'footers.digitalCardTemplateForQr' | translate"
                    [options]="digitalCardTemplates"
                    [displayWith]="digitalCardTemplateLabel"
                    [valueWith]="digitalCardTemplateValue"
                    [emptyLabel]="'settings.defaultDigitalCardTemplateNone' | translate"
                    [emptyValue]="null"
                    [loading]="digitalCardTemplatesLoading"
                    (opened)="loadDigitalCardTemplates()"
                  ></app-searchable-select>
                </div>

                <div class="field-row">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ "footers.phoneLabel" | translate }}</mat-label>
                    <input matInput formControlName="phoneLabel" type="text" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ "footers.mobileLabel" | translate }}</mat-label>
                    <input matInput formControlName="mobileLabel" type="text" />
                  </mat-form-field>
                </div>

                <div class="field-row">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ "footers.emailLabel" | translate }}</mat-label>
                    <input matInput formControlName="emailLabel" type="text" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ "footers.customLabel" | translate }}</mat-label>
                    <input matInput formControlName="customLabel" type="text" />
                  </mat-form-field>
                </div>

                <app-searchable-select
                  class="field-half"
                  formControlName="customLabelVariable"
                  [label]="'footers.customLabelVariable' | translate"
                  [options]="customLabelVariableOptions"
                  [displayWith]="identityLabel"
                  [valueWith]="identityLabel"
                  [emptyLabel]="'footers.customLabelVariableNone' | translate"
                  [emptyValue]="null"
                ></app-searchable-select>

                <div class="field-row">
                  <div class="color-field">
                    <span class="color-field__label">{{
                      "footers.labelColor" | translate
                    }}</span>
                    <div class="color-field__controls">
                      <input
                        type="color"
                        [value]="form.get('labelColor')?.value || '#f0f0f0'"
                        (input)="onLabelColorChange($event)"
                        class="color-input"
                      />
                      <input
                        type="text"
                        class="color-hex-input"
                        formControlName="labelColor"
                        (blur)="onLabelColorHexBlur($event)"
                        (keyup.enter)="onLabelColorHexBlur($event)"
                        [placeholder]="
                          'footers.labelColorPlaceholder' | translate
                        "
                      />
                    </div>
                  </div>
                  <div class="color-field">
                    <span class="color-field__label">{{
                      "footers.labelTextColor" | translate
                    }}</span>
                    <div class="color-field__controls">
                      <input
                        type="color"
                        [value]="form.get('labelTextColor')?.value || '#333333'"
                        (input)="onLabelTextColorChange($event)"
                        class="color-input"
                      />
                      <input
                        type="text"
                        class="color-hex-input"
                        formControlName="labelTextColor"
                        (blur)="onLabelTextColorHexBlur($event)"
                        (keyup.enter)="onLabelTextColorHexBlur($event)"
                        [placeholder]="
                          'footers.labelTextColorPlaceholder' | translate
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="section" [class.hidden]="activeSection !== 'variables'">
              <app-variable-palette
                [targetEditor]="getActiveEditor()"
                [isExternalExpanded]="true"
              >
              </app-variable-palette>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  @if (loading || !footer) {
    <div class="dbc1-loading dbc1-loading--overlay">
      <app-loading></app-loading>
    </div>
  }
</div>
